<template>
  <div v-if="visible" class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-8 animate-fade-in relative">
      <button @click="close" class="absolute top-4 right-4 text-gray-medium hover:text-dark transition-custom">
        <i class="fas fa-times text-xl"></i>
      </button>
      <div class="text-center mb-6">
        <h3 class="text-2xl font-bold text-dark">人才入库申请</h3>
        <p class="mt-2 text-gray-medium">请填写以下信息申请加入人才库</p>
      </div>
      <form @submit.prevent="handleSubmit" class="space-y-5">
        <div>
          <label for="talentType" class="block text-sm font-medium text-gray-dark mb-1">人才分类 <span class="text-danger">*</span></label>
          <select 
            id="talentType" 
            v-model="form.typeId"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom bg-white"
            required
          >
            <option value="">请选择分类</option>
            <option 
              v-for="category in categories" 
              :key="category.id" 
              :value="category.id"
            >
              {{ category.title }}
            </option>
          </select>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div>
            <label for="talentName" class="block text-sm font-medium text-gray-dark mb-1">姓名 <span class="text-danger">*</span></label>
            <input 
              type="text" 
              id="talentName" 
              v-model="form.name"
              class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
              placeholder="请输入姓名" 
              required
            >
          </div>
          <div>
            <label for="talentGender" class="block text-sm font-medium text-gray-dark mb-1">性别</label>
            <select 
              id="talentGender" 
              v-model="form.gender"
              class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom bg-white"
            >
              <option value="">请选择</option>
              <option value="男">男</option>
              <option value="女">女</option>
            </select>
          </div>
        </div>
        <div>
          <label for="talentPhone" class="block text-sm font-medium text-gray-dark mb-1">手机号码 <span class="text-danger">*</span></label>
          <input 
            type="tel" 
            id="talentPhone" 
            v-model="form.phone"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入手机号码" 
            required
          >
        </div>
        <div>
          <label for="teacherName" class="block text-sm font-medium text-gray-dark mb-1">指导老师姓名 <span class="text-danger">*</span></label>
          <input 
            type="text" 
            id="teacherName" 
            v-model="form.teacherName"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入指导老师姓名（没有填无）" 
            required
          >
        </div>
        <div>
          <label for="currentCity" class="block text-sm font-medium text-gray-dark mb-1">现居住城市</label>
          <input 
            type="text" 
            id="currentCity" 
            v-model="form.liveCity"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入现居住城市，如：河南省郑州市" 
          >
        </div>
        <div>
          <label for="talentEducation" class="block text-sm font-medium text-gray-dark mb-1">最高学历</label>
          <select 
            id="talentEducation" 
            v-model="form.education"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom bg-white"
          >
            <option value="">请选择</option>
            <option value="高中及以下">高中及以下</option>
            <option value="专科">专科</option>
            <option value="本科">本科</option>
            <option value="硕士">硕士</option>
            <option value="博士及以上">博士及以上</option>
          </select>
        </div>
        <div>
          <label for="talentWorkExp" class="block text-sm font-medium text-gray-dark mb-1">工作经验</label>
          <select 
            id="talentWorkExp" 
            v-model="form.workExp"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom bg-white"
          >
            <option value="">请选择</option>
            <option value="应届毕业生">应届毕业生</option>
            <option value="1-3年">1-3年</option>
            <option value="3-5年">3-5年</option>
            <option value="5-10年">5-10年</option>
            <option value="10年以上">10年以上</option>
          </select>
        </div>
        <div>
          <label for="talentSkills" class="block text-sm font-medium text-gray-dark mb-1">专业技能</label>
          <input 
            type="text" 
            id="talentSkills" 
            v-model="form.skills"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入专业技能，多个技能用逗号分隔" 
          >
        </div>
        <div>
          <label for="talentCertificates" class="block text-sm font-medium text-gray-dark mb-1">所持证书</label>
          <input 
            type="text" 
            id="talentCertificates" 
            v-model="form.certificates"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入所持证书，多个证书用逗号分隔" 
          >
        </div>
        <div>
          <label for="careerPlan" class="block text-sm font-medium text-gray-dark mb-1">职业规划 <span class="text-danger">*</span></label>
          <select 
            id="careerPlan" 
            v-model="form.careerPlan"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom bg-white"
            required
          >
            <option value="">请选择职业规划</option>
            <option value="在职">在职</option>
            <option value="想求职">想求职</option>
            <option value="想创业">想创业</option>
            <option value="想合作">想合作</option>
          </select>
        </div>
        <div v-if="form.careerPlan === '想求职'">
          <label for="intentCity" class="block text-sm font-medium text-gray-dark mb-1">意向城市 <span class="text-danger">*</span></label>
          <input 
            type="text" 
            id="intentCity" 
            v-model="form.intentCity"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入意向工作城市" 
            :required="form.careerPlan === '想求职'"
          >
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-dark mb-1">证书照片</label>
          <div class="border-2 border-dashed border-gray-light rounded-lg p-6 text-center hover:border-primary transition-custom cursor-pointer bg-gray-50" :class="{ 'opacity-50 pointer-events-none': uploading }">
            <input type="file" class="hidden" id="talentCertImages" multiple accept="image/*" @change="handleFileUpload" :disabled="uploading">
            <label for="talentCertImages" class="cursor-pointer">
              <i class="fa text-3xl text-gray-medium mb-2" :class="uploading ? 'fa-spinner fa-spin' : 'fa-cloud-upload'"></i>
              <p class="text-sm text-gray-medium">{{ uploading ? '上传中...' : '点击上传证书照片（可上传多张）' }}</p>
              <p class="text-xs text-gray-medium mt-1">支持JPG、PNG格式，单文件不超过5MB</p>
            </label>
          </div>
          <div v-if="uploadedImages.length > 0" class="mt-3 grid grid-cols-3 sm:grid-cols-4 gap-2">
            <div 
              v-for="(image, index) in uploadedImages" 
              :key="index" 
              class="relative group"
            >
              <img :src="image.fullUrl" alt="证书图片" class="w-full h-20 object-cover rounded-lg border-2 border-gray-light">
              <button 
                type="button"
                @click="removeImage(index)"
                class="absolute top-1 right-1 bg-danger text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <i class="fas fa-times text-xs"></i>
              </button>
            </div>
          </div>
        </div>
        <div>
          <label for="talentIntroduction" class="block text-sm font-medium text-gray-dark mb-1">个人简介</label>
          <textarea 
            id="talentIntroduction" 
            rows="4" 
            v-model="form.introduction"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请简要介绍个人经历、专业能力等"
          ></textarea>
        </div>
        <button 
          type="submit" 
          :disabled="submitting"
          class="w-full py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-custom shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="submitting">
            <i class="fas fa-spinner fa-spin mr-2"></i>
            提交中...
          </span>
          <span v-else>提交申请</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { submitTalentApplication, uploadFile } from '@/api/index'
import { talentAPI } from '@/api/services'

export default {
  name: 'TalentModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categories: [], // 分类列表
      form: {
        typeId: '', // 添加分类ID字段
        name: '',
        gender: '',
        phone: '',
        teacherName: '', // 指导老师姓名
        liveCity: '', // 现居住城市
        education: '',
        workExp: '',
        skills: '',
        certificates: '',
        careerPlan: '', // 职业规划
        intentCity: '', // 意向城市
        introduction: ''
      },
      uploadedImages: [],
      uploading: false,
      submitting: false
    }
  },
  created() {
    // 组件创建时加载分类列表
    this.fetchCategories()
  },
  methods: {
    // 获取分类列表
    async fetchCategories() {
      try {
        const response = await talentAPI.getCategories()
        
        // 后端返回格式: [{id: 2, title: "商业管理", status: "1", weigh: 2}, ...]
        if (response && Array.isArray(response)) {
          this.categories = response
        } else {
          console.warn('分类列表数据格式不正确')
          this.categories = []
        }
      } catch (error) {
        console.error('获取分类列表失败:', error)
        this.categories = []
      }
    },
    close() {
      this.$emit('close')
      document.body.style.overflow = ''
    },
    async handleFileUpload(event) {
      const files = Array.from(event.target.files)
      if (files.length === 0) return
      
      const maxSize = 5 * 1024 * 1024
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      
      for (const file of files) {
        if (file.size > maxSize) {
          this.$message.error(`文件 ${file.name} 超过5MB限制`)
          event.target.value = ''
          return
        }
        if (!allowedTypes.includes(file.type)) {
          this.$message.error(`文件 ${file.name} 格式不支持`)
          event.target.value = ''
          return
        }
      }
      
      this.uploading = true
      
      try {
        for (const file of files) {
          const formData = new FormData()
          formData.append('file', file)
          
          const response = await uploadFile(formData)
          
          this.uploadedImages.push({
            path: response.data.url,
            fullUrl: response.data.fullurl
          })
        }
      } catch (error) {
        console.error('上传失败:', error)
        this.$message.error(error.msg || error.message || '图片上传失败')
      } finally {
        this.uploading = false
        event.target.value = ''
      }
    },
    removeImage(index) {
      this.uploadedImages.splice(index, 1)
    },
    async handleSubmit() {
      if (this.submitting) return

      // 验证必填字段
      if (!this.form.typeId) {
        this.$message.error('请选择人才分类')
        return
      }

      if (!this.form.name || !this.form.phone) {
        this.$message.error('请填写姓名和手机号码')
        return
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }

      if (!this.form.teacherName) {
        this.$message.error('请填写指导老师姓名')
        return
      }

      if (!this.form.careerPlan) {
        this.$message.error('请选择职业规划')
        return
      }

      if (this.form.careerPlan === '想求职' && !this.form.intentCity) {
        this.$message.error('请输入意向城市')
        return
      }

      try {
        this.submitting = true

        const imageUrl = this.uploadedImages.map(img => img.path).join(',')

        // 将中文逗号转换为英文逗号
        const skills = this.form.skills.replace(/，/g, ',')
        const certificates = this.form.certificates.replace(/，/g, ',')

        const response = await submitTalentApplication({
          type_id: this.form.typeId, // 添加分类ID参数
          name: this.form.name,
          gender: this.form.gender,
          phone: this.form.phone,
          teacher_name: this.form.teacherName, // 指导老师姓名
          live_city: this.form.liveCity, // 现居住城市
          education: this.form.education,
          work_exp: this.form.workExp,
          skills: skills,
          certificates: certificates,
          career_plan: this.form.careerPlan, // 职业规划
          intent_city: this.form.careerPlan === '想求职' ? this.form.intentCity : '', // 意向城市（仅在想求职时提交）
          introduction: this.form.introduction,
          cert_images: imageUrl
        })
        
        if (response.code == 1) {
          this.$message.success('申请已提交')
          this.resetForm()
          this.close()
        } else {
          this.$message.error(response.msg || response.message || '提交失败')
        }
      } catch (error) {
        this.$message.error(error.msg || error.message || '提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },
    resetForm() {
      this.form = {
        typeId: '', // 重置分类ID
        name: '',
        gender: '',
        phone: '',
        teacherName: '', // 重置指导老师姓名
        liveCity: '', // 重置现居住城市
        education: '',
        workExp: '',
        skills: '',
        certificates: '',
        careerPlan: '', // 重置职业规划
        intentCity: '', // 重置意向城市
        introduction: ''
      }
      this.uploadedImages = []
      const fileInput = document.getElementById('talentCertImages')
      if (fileInput) fileInput.value = ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.overflow-y-auto {
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style> 